import { Grid, Typography, Stack, Box, Link } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { RiPulseFill } from 'react-icons/ri';
import { getCurrentUserTeams, IWorkAssignment } from 'wisestep-api';
import {
  WsColors,
  timeSince,
  WsTypography,
  WsTypoColors,
  WsTypoVariants,
  getDateUsingFormat,
  WsIconText,
} from 'wisestep-base';

export const isTeamMember = async (teamId: string) => {
  try {
    const currentUserTeams = await getCurrentUserTeams();
    const currentTeamIds = [
      ...(currentUserTeams.data?.ownsTeams ?? []),
      ...(currentUserTeams.data?.belongsToTeams ?? []),
    ];
    return currentTeamIds.includes(teamId);
  } catch (error) {
    console.error('Error getting current user teams', error);
  }
};

interface PostedByProps {
  createdOn: string;
  teamName: string;
  teamId?: string;
  loggedInUserId: string;
  assignedTo: IWorkAssignment[];
  canManageJob: boolean;
  jobOwner: string;
  createdBy: string;
  modifiedOn: Date;
  modifiedBy: string;
}
const PostedBy = ({
  createdOn,
  teamName,
  teamId,
  assignedTo,
  loggedInUserId,
  canManageJob,
  jobOwner,
  createdBy,
  modifiedOn,
  modifiedBy,
}: PostedByProps) => {
  const isAssigned =
    loggedInUserId && assignedTo?.filter((user) => user.recruiterId == loggedInUserId);
  return (
    <Grid container pt={1} spacing={0.5} justifyContent="space-between">
      <Grid item xs={0.3}>
        <RiPulseFill color={WsColors.TheBlues500} />
      </Grid>
      <Grid item xs={11.7} justifyContent="flex-start">
        <Stack direction="row" spacing={0.5}>
          {canManageJob && (
            <Box display="flex">
              <WsTypography
                variant={WsTypoVariants.BODY2}
                color={WsTypoColors.BLACK}
                cursor="pointer"
                hoverText={
                  createdOn ? getDateUsingFormat(String(createdOn), 'D MMMM YYYY, HH:mm') : ''
                }
              >
                {`Posted ${timeSince(String(createdOn))} by`}
              </WsTypography>
              <Link
                href={`/recruiter/profile?email=${createdBy}&isLink=true&goBackUrl=/jobs`}
                underline="none"
              >
                <WsTypography
                  variant={WsTypoVariants.BODY2}
                  color={WsTypoColors.PRIMARY600}
                  cursor="pointer"
                >
                  {jobOwner}
                </WsTypography>
              </Link>
            </Box>
          )}
          {!canManageJob && isAssigned && (
            <WsTypography
              hoverText={
                createdOn ? getDateUsingFormat(String(createdOn), 'D MMMM YYYY, HH:mm') : ''
              }
              variant={WsTypoVariants.BODY2}
              color={WsTypoColors.BLACK}
              cursor="pointer"
            >{`Assigned : ${createdOn && timeSince(String(createdOn))} by ${
              isAssigned?.[0]?.assignedBy ?? ''
            }  |  ${jobOwner} `}</WsTypography>
          )}
          {!isEmpty(teamName) && (
            <Link
              href={`/team/team-members-view?teamId=${teamId}&teamName=${teamName}&goBackUrl=/jobs`}
              underline="none"
            >
              <Typography
                pl={0.5}
                fontSize="12px"
                fontWeight="bold"
                color={WsColors.TertiaryShades700}
                sx={{ cursor: 'pointer' }}
              >
                {`| #${teamName}`}
              </Typography>
            </Link>
          )}
          {canManageJob &&
            isEmpty(teamName) &&
            !teamName &&
            loggedInUserId === createdBy &&
            canManageJob && (
              <Typography pl={0.5} fontSize="13px" fontWeight="bold" color={WsColors.TheBlues500}>
                {`| #Private`}
              </Typography>
            )}
          <>
            <WsIconText
              textCursor="pointer"
              text={`Updated ${timeSince(String(modifiedOn))} `}
              icon={<RiPulseFill color={WsColors.TheBlues500} />}
              popOverText={
                modifiedOn ? getDateUsingFormat(String(modifiedOn), 'D MMMM YYYY, HH:mm') : ''
              }
            />
            <Link
              href={`/users/details-page?email=${
                modifiedBy ?? ''
              }&isLink=true&isUserAnalytics=true&goBackUrl=${window.location.pathname}`}
              underline="none"
            >
              <WsTypography
                variant={WsTypoVariants.BODY2}
                color={WsTypoColors.PRIMARY600}
                cursor="pointer"
              >
                {modifiedBy ?? ''}
              </WsTypography>
            </Link>
          </>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default PostedBy;
